<p
  mat-dialog-title
  class="title">
  Change responsibles
</p>
<mat-dialog-content>
  @if (form) {
  <div [formGroup]="form">
    <div>
      <div class="controller-title flex-center">
        <strong>1. Auditee</strong><br />
        <span class="controller-text bold"
          >{{ form.get('assessmentCoordinator')?.value | userName: form.get('assessmentCoordinatorName')?.value | async }}
          {{ form.get('assessmentCoordinator')?.value | azureIdStatus | async }}
        </span>
        <ng-container>
          <button
            mat-button
            (click)="selectPerson('assessmentCoordinator', true)">
            <mat-icon
              class="icon-button orangeText"
              style="vertical-align: middle"
              >person_add</mat-icon
            >
          </button>
        </ng-container>
      </div>

      <div class="controller-title flex-center">
        <strong>2. LU responsibles</strong><br />
        <span class="controller-text bold"
          >{{ form.get('legalUnitResponsibles')?.value | userName: form.get('legalUnitResponsiblesNames')?.value | async }}
          {{ form.get('legalUnitResponsibles')?.value | azureIdStatus | async }}
        </span>
        <ng-container>
          <button
            mat-button
            (click)="selectPerson('legalUnitResponsibles')">
            <mat-icon
              class="icon-button orangeText"
              style="vertical-align: middle"
              >person_add</mat-icon
            >
          </button>
        </ng-container>
      </div>

      <div class="controller-title flex-center">
        <strong>3. Others</strong><br />
        <span class="controller-text bold"
          >{{ form.get('otherResponsibles')?.value | userName: form.get('otherResponsiblesNames')?.value | async }}
          {{ form.get('otherResponsibles')?.value | azureIdStatus | async }}
        </span>
        <ng-container>
          <button
            mat-button
            (click)="selectPerson('otherResponsibles')">
            <mat-icon
              class="icon-button orangeText"
              style="vertical-align: middle"
              >person_add</mat-icon
            >
          </button>
        </ng-container>
      </div>
      <div><strong>4. Email Adresses no Application Access</strong></div>
      <div class="mailElements">
        @for (mail of form.get('emailAddress')?.value; track mail; let i = $index) {
        <div class="mailSelect">
          {{ mail }}
          @if (!disabled) {
          <button
            class="remove-mail-btn"
            aria-label="Remove email"
            (click)="removeMail(i)"
            (keydown.enter)="removeMail(i)"
            (keydown.space)="removeMail(i)"
            tabindex="0">
            <em class="material-icons md-18">close</em>
          </button>
          }
        </div>
        }
      </div>
      <div class="clear"></div>
    </div>
    <div>
      <p>{{ form.value.legalUnit }}</p>
    </div>
    @for (field of fields; track field) {
    <div>
      @for (person of field.persons; track person; let i = $index) {
      <div class="keyperson">
        @if (person.name && isValidName(person.name)) {
        <!-- Can't have multiple template bindings in a single tag -->
        <div class="col-sm-12 col-md-3 column">{{ findName(field.key) }}</div>
        @if (person.name) {
        <div class="col-sm-12 col-md-3 column">
          {{ person.name }}
        </div>
        } @if (person.id) {
        <button
          mat-button
          (click)="sendToUserSelect(person, 'assessmentCoordinator')"
          class="mat-raised-button col-sm-12 col-md-1 addassessmentCoordinator addButton">
          ADD
        </button>
        } @if (person.id) {
        <button
          mat-button
          (click)="sendToUserSelect(person, 'legalUnitResponsibles')"
          class="mat-raised-button col-sm-12 col-md-1 addLegalUnit addButton">
          ADD
        </button>
        } @if (person.id) {
        <button
          mat-button
          (click)="sendToUserSelect(person, 'otherResponsibles')"
          class="mat-raised-button col-sm-12 col-md-1 addOthers addButton">
          ADD
        </button>
        } @if (!person.id) {
        <button
          mat-button
          (click)="addMail(person.mail)"
          class="mat-raised-button col-sm-12 col-md-1 addEmail addButton">
          ADD Mail only
        </button>
        } }
      </div>
      }
    </div>
    }
  </div>
  }
  <div class="close">
    <button
      color="primary"
      mat-raised-button
      [mat-dialog-close]="true">
      Close
    </button>
  </div>
</mat-dialog-content>
